// Consent record read/write, extracted out of CookieBanner.tsx so
// analytics.ts can check consent without importing a component. Importing
// CookieBanner directly from analytics.ts would create a cycle: CookieBanner
// already imports grantAnalyticsConsent/revokeAnalyticsConsent from
// analytics.ts. This module has no dependency on either, so both can
// import from it safely.

const STORAGE_KEY = "cookie_consent";
const EXPIRY_DAYS = 365;

export type ConsentStatus = "accepted" | "declined";

export interface ConsentRecord {
  status: ConsentStatus;
  timestamp: number;
}

export function getStoredConsent(): ConsentRecord | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const record: ConsentRecord = JSON.parse(raw);
    const ageMs = Date.now() - record.timestamp;
    if (ageMs > EXPIRY_DAYS * 24 * 60 * 60 * 1000) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return record;
  } catch {
    return null;
  }
}

export function saveConsentRecord(status: ConsentStatus): void {
  try {
    const record: ConsentRecord = { status, timestamp: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    // Private mode or storage quota exceeded — ignore silently
  }
}

// 다른 모듈에서 동의 여부 확인할 때 사용
export function hasAnalyticsConsent(): boolean {
  const record = getStoredConsent();
  return record?.status === "accepted";
}
